import { message } from '../notifications';

type CopyMessage = {
  success: string;
  error: string;
};

const legacyCopy = (value: string): boolean => {
  if (typeof document === 'undefined' || !document.body) {
    return false;
  }

  const textArea = document.createElement('textarea');
  textArea.value = value;
  textArea.setAttribute('readonly', '');
  textArea.style.position = 'fixed';
  textArea.style.left = '-9999px';
  textArea.style.top = '0';
  textArea.style.opacity = '0';
  textArea.style.pointerEvents = 'none';

  document.body.appendChild(textArea);

  try {
    textArea.focus();
    textArea.select();
    textArea.setSelectionRange(0, textArea.value.length);

    const maybeExecCommand = (document as unknown as { execCommand?: unknown })
      .execCommand;

    if (typeof maybeExecCommand !== 'function') {
      return false;
    }

    return (
      maybeExecCommand as (this: Document, commandId: string) => boolean
    ).call(document, 'copy');
  } catch {
    return false;
  } finally {
    document.body.removeChild(textArea);
  }
};

export const copyToClipboard = async (
  value: string,
  withoutMessage: boolean = false,
  text: CopyMessage = { success: '', error: '' }
) => {
  const canUseClipboardApi =
    typeof navigator !== 'undefined' && !!navigator.clipboard?.writeText;

  try {
    let copied = false;

    if (canUseClipboardApi) {
      try {
        await navigator.clipboard.writeText(value);
        copied = true;
      } catch {
        copied = legacyCopy(value);
      }
    } else {
      copied = legacyCopy(value);
    }

    if (!copied) {
      throw new Error('Clipboard copy failed');
    }

    if (!withoutMessage) {
      message({
        type: 'success',
        text: text.success || 'Скопировано в буфер обмена',
      });
    }
  } catch (error) {
    console.error(error);

    if (!withoutMessage) {
      message({ type: 'error', text: text.error || 'Не удалось скопировать' });
    }

    throw error;
  }
};
